import React, { memo } from 'react'
import styled from 'styled-components'
import imgNoData from 'assets/images/no-data.png'
import imgNoDataAstro from 'assets/images/no-data-astro.png'
import { Typography } from '@astro-ui/components'

interface NoDataInterface {
  withAstroIcon?: boolean
  TextHeading?: React.ReactNode
  TextDescription?: string
  ActionComponent?: React.ReactNode
  containerStyle?: React.CSSProperties
  imgStyle?: React.CSSProperties
  customIcon?: string
}
function NoData({
  withAstroIcon = false,
  TextHeading,
  TextDescription,
  ActionComponent,
  containerStyle,
  imgStyle,
  customIcon,
}: NoDataInterface) {
  const imgSrc = customIcon || (withAstroIcon ? imgNoDataAstro : imgNoData)
  return (
    <Container style={containerStyle}>
      <Img withAstroIcon={withAstroIcon} src={imgSrc} alt="no data" style={imgStyle} />
      {withAstroIcon && (
        <Typography sx={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '8px' }}>
          {TextHeading}
        </Typography>
      )}
      <Typography sx={{ color: '#525a67', fontWeight: 300 }}>
        {withAstroIcon ? TextDescription : 'Tidak ada data'}
      </Typography>
      {!!ActionComponent && ActionComponent}
    </Container>
  )
}

export default memo(NoData)

type ImgPropsType = {
  withAstroIcon: boolean
}

const Img = styled.img<ImgPropsType>`
  width: ${({ withAstroIcon }) => (withAstroIcon ? 'auto' : '50px')};
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  width: 100%;
`
